import comp from "./DialogBox";
export default comp;
